import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelOtaRoomTypes } from "../../../../HotelOtaRoomTypes"
import { useOutletContext } from "../../../../router-utils"

export default function HotelRoomTypesPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Room Types | Hotel</title>
			</Helmet>
			<HotelOtaRoomTypes hotel={hotel} onChange={revalidate} />
		</>
	)
}
